import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { NotificationsResponse } from '../../interfaces/notification.interface';

export const NotificationActions = createActionGroup({
  source: 'Notifications',
  events: {
    'Start polling': emptyProps(),
    'Stop polling': emptyProps(),
    Load: emptyProps(),
    'Load success': props<{ data: NotificationsResponse }>(),
    'Load failure': props<{ error: HttpErrorResponse }>(),
    'Mark read': props<{ id: string }>(),
    'Mark read success': props<{ id: string }>(),
    'Mark read failure': props<{ error: HttpErrorResponse }>(),
    'Mark all read': emptyProps(),
    'Mark all read success': props<{ data: NotificationsResponse }>(),
    'Mark all read failure': props<{ error: HttpErrorResponse }>(),
  },
});
